<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="title || $t('Message.SendFileVerification')"
    width="820px"
    :close-on-click-modal="false"
  >
    <div class="check-tip">
      <img :src="isPass ? trueIcon : falseIcon" style="margin-bottom: 15px;">
      <div v-show="matchInstructionTip">{{ matchInstructionTip }}</div>
      <div v-show="masterInfo">{{ masterInfo }}</div>
      <div v-show="slaveInfo">{{ slaveInfo }}</div>
      <div :style="{ marginTop: '15px', marginBottom: multiFieldSampleError ? '10px' : '', fontSize: '16px', color: 'red', height: multiFieldSampleError ? '' : '0px' }">{{ multiFieldSampleError }}</div>
      <div v-show="isPass">{{ $t('Message.SendFileVerificationSuccessTip') }}</div>
      <div v-show="!isPass">{{ $t('Message.SendFileVerificationExceptionTip') }}</div>
      <div>{{ $t('queryJob.ClickFilePrivew') }}</div>
    </div>
    <!-- <div class="check-detail">
      <el-scrollbar>
        <div class="check-detail-table">
          <ul>
            <li><line-label :label="$t('CargoMsg.Cargo_SerialNo')" /></li>
            <li><line-label :label="$t('Message.OddNumbers')" /></li>
            <li><line-label :label="$t('SeaExport.BillLadingIssued')" /></li>
            <li><line-label :label="$t('Message.Info')" /></li>
            <li><line-label :label="$t('Message.Validating')" /></li>
          </ul>
          <div v-for="(row,index) in rowData" :key="index" class="check-detail-row">
            <div><line-label :label="String(row.no)" /></div>
            <div><line-label :label="row.jobNo" /></div>
            <div><line-label :label="getBliStatus(row)" /></div>
            <div><line-label :label="row.info" /></div>
            <div><img :src="row.isExist ? acceptIcon : rejectIcon"></div>
          </div>
        </div>
      </el-scrollbar>
    </div> -->
    <el-table :data="rowData" :height="310" :span-method="onSpanMethod">
      <el-table-column prop="no" :label="$t('CargoMsg.Cargo_SerialNo')" width="70" align="center" show-overflow-tooltip />
      <el-table-column prop="containerNo" :label="$t('SeaExport.ContainerNo')" width="110" align="center" show-overflow-tooltip />
      <el-table-column prop="businessNo" :label="$t('SeaExport.BusinessSeq')" width="70" align="center" show-overflow-tooltip />
      <el-table-column prop="jobNo" :label="$t('Message.OddNumbers')" width="130" align="center" show-overflow-tooltip />
      <el-table-column prop="bliStatus" :label="$t('SeaExport.BillLadingIssued')" width="100" align="center" show-overflow-tooltip>
        <template slot-scope="{row}">
          <div>{{ getBliStatus(row) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="info" :label="$t('Message.Info')" width="230" align="center" show-overflow-tooltip>
        <template slot-scope="{row}">
          <div v-if="row.fileId && ['jpg','png','jpeg','gif','webp','pdf','doc','docx','xls','xlsx'].includes(row.fileType)">
            <a style="text-decoration: underline;text-decoration-color: blue;" @click="handlePreviewFile(row.fileId, row.info + '.' + row.fileType)">{{ row.info }}</a>
          </div>
          <div v-else>{{ row.info }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="isExist" :label="$t('Message.Validating')" width="88" align="center" show-overflow-tooltip>
        <template slot-scope="{row}">
          <div><img :src="row.isExist ? acceptIcon : rejectIcon"></div>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer">
      <el-button v-show="showNext" type="primary" @click="onNext">{{ $t('CargoMsg.Cargo_Next') }}</el-button>
      <el-button type="danger" @click="innerVisible = false">{{ $t('Message.Cancel') }}</el-button>
    </span>
    <!-- 预览文件弹窗 -->
    <pre-view-file-dialog
      :v-if="previewFileData.visible"
      :title="$t('FileHistory.preview')"
      :visible="previewFileData.visible"
      :file="previewFileData.file"
      :can-maximize="true"
      @close="closePreviewDialog"
    />
  </el-dialog>
</template>

<script>
import trueIcon from '@/assets/true-x32.png'
import falseIcon from '@/assets/false-x32.png'
import acceptIcon from '@/assets/accept-x16.png'
import rejectIcon from '@/assets/reject-x16.png'
import ColumnUtils from '@/utils/ColumnUtils'
import preViewFileDialog from '@/components/Cargo/Common/preViewFileCommonDialog'

export default {
  name: 'CheckingSendDestinationAgentWindow',
  components: { preViewFileDialog },
  props: {
    visible: { type: Boolean, required: true },
    isPass: { type: Boolean, required: true },
    masterInfo: { type: String, default: '' },
    slaveInfo: { type: String, default: '' },
    rowData: { type: Array, default: () => [] },
    showNext: { type: Boolean, required: true },
    matchInstructionTip: { type: String, default: '' },
    title: { type: String, default: '' },
    multiFieldSample: { type: Object, default: null }
  },
  data() {
    return {
      innerVisible: this.visible,
      trueIcon,
      falseIcon,
      acceptIcon,
      rejectIcon,
      previewFileData: {
        visible: false,
        file: null
      }
    }
  },
  computed: {
    multiFieldSampleError() {
      if (this.multiFieldSample) {
        const errorItemNames = []
        for (const key in this.multiFieldSample) {
          if (this.multiFieldSample[key]) {
            continue
          }
          switch (key) {
            case 'vesselSame':
              errorItemNames.push('【' + this.$t('queryJob.vessel') + '】')
              break
            case 'voyageFlightSame':
              errorItemNames.push('【' + this.$t('SeaExport.Voyage') + '】')
              break
            case 'destinationAgentSame':
              errorItemNames.push('【' + this.$t('queryJob.destinationAgent') + '】')
              break
            case 'dischargingPortCodeSame':
              errorItemNames.push('【' + this.$t('queryJob.dischargingPortCode') + '】')
              break
            case 'etdSame':
              errorItemNames.push('【' + this.$t('queryJob.dateOfDeparture') + '】')
              break
          }
        }
        if (errorItemNames.length > 0) {
          return this.$t('queryJob.BusinessOfTheSelectedMatch', [errorItemNames.join('')])
        }
      }
      return ''
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    onNext() {
      this.innerVisible = false
      this.$emit('next')
    },
    getBliStatus(row) {
      // 避免0值被转换为false
      if (String(row.bliStatus) !== 'undefined') {
        return ColumnUtils.bliStatusLabelFunc(row.bliStatus)
      } else {
        return '-'
      }
    },
    onSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1) {
        const row = this.rowData[rowIndex]
        return { rowspan: row.rowspan, colspan: 1 }
      }
      return { rowspan: 1, colspan: 1 }
    },
    handlePreviewFile(fileId, fileName) {
      this.previewFileData.file = { fileId, fileName }
      this.previewFileData.visible = true
    },
    closePreviewDialog() {
      this.previewFileData.file = null
      this.previewFileData.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .check-detail {
    border: 1px solid #EAEEF5;
    height: 310px;
    > .el-scrollbar {
      height: 310px;
      .el-scrollbar__wrap {
        overflow-x: hidden;
        .el-scrollbar__view {
          padding-bottom: 20px;
        }
      }
      .is-vertical {
        opacity: 1;
        .el-scrollbar__thumb {
          background-color: rgba(153, 153, 153, 0.8);
        }
      }
    }
    .line-label {
      font-size: 14px;
    }
  }
  .el-table {
    border: 1px solid #DCDFE6;
    th.el-table__cell,
    td.el-table__cell {
      border-right: 1px solid #DCDFE6;
    }
    th:last-child.el-table__cell,
    td:last-child.el-table__cell {
      border-right: none;
    }
    .el-table__header-wrapper {
      th.el-table__cell {
        background: #F2F2F2;
      }
    }
    .el-table__body-wrapper {
      &.is-scrolling-right {
        padding-right: 0;
      }
      padding-right: 22px;
    }
    tr {
      td:last-child {
        div.cell {
          padding-right: 23px;
        }
      }
    }
  }
}
.check-tip {
  margin: 5px 0 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #000;
  > div {
    width: 100%;
    padding-left: 20px;
    font-size: 14px;
    margin-top: 2px;
  }
}
.check-detail-table {
  > ul {
    margin: 0 0 10px 0;
    padding-left: 0px;
    height: 32px;
    background-color: #F2F2F2;
    display: flex;
    align-items: center;
    li {
      list-style: none;
      text-align: center;
      color: #000;
      font-weight: bold;
      &:first-of-type{
        width: 10%;
      }
      &:nth-of-type(2){
        width: 20%;
      }
      &:nth-of-type(3){
        width: 20%;
      }
      &:nth-of-type(4){
        width: 40%;
      }
      &:nth-of-type(5){
        width: 10%;
      }
    }
  }
  .check-detail-row {
    display: flex;
    > div {
      line-height: 30px;
      color: #000;
      text-align: center;
      &:first-of-type {
        width: 10%;
      }
      &:nth-of-type(2){
        width: 20%;
      }
      &:nth-of-type(3){
        width: 20%;
      }
      &:nth-of-type(4){
        width: 40%;
      }
      &:nth-of-type(5){
        width: 10%;
        img {
          vertical-align:  middle;
        }
      }
    }
  }
}
</style>
